import { useQueries, UseQueryOptions } from 'react-query';
import {
  InstagramGroup,
  getBusinessInstagramAccounts,
  getPageInstagramAccounts,
  getShadowInstagramAccounts,
} from '~/api/routes/instagram';
import { usePageQuery } from './usePageQuery';

type UseInstagramAccountsQueryOptions<TError, TData> = UseQueryOptions<InstagramGroup, TError, TData>;

export function useInstagramAccountQueries<TError = unknown, TData = InstagramGroup>(
  options?: Omit<UseInstagramAccountsQueryOptions<TError, TData>, 'enabled'> = {},
) {
  const [pageId, _, { isLoading }] = usePageQuery();

  return useQueries([
    {
      queryKey: ['instagram', 'business'],
      queryFn: getBusinessInstagramAccounts,
      ...options,
    },
    {
      queryKey: ['instagram', 'page', pageId],
      queryFn: () => getPageInstagramAccounts(pageId as string),
      enabled: !!pageId && !isLoading,
      ...options,
    },
    {
      queryKey: ['instagram', 'shadow', pageId],
      queryFn: () => getShadowInstagramAccounts(pageId as string),
      enabled: !!pageId && !isLoading,
      ...options,
    },
  ]);
}
